var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cbutton class=\"btn btn-sm btn-outline-danger\" type=\"button\" ng-click=\"$ctrl.open()\" ng-disabled=\"$ctrl.disabled\"\u003E{{$ctrl.text}} \u003C\u002Fbutton\u003E";;return pug_html;};
module.exports = template;